// El color con el que se pinta una opción del alcance cuando el DATO tiene el suyo: el metal del
// nivel y el slot del segmento, en vez del color plano de la dimensión.
import { ClientLevelEnum } from '@fiado/type-kit/bin/loanScoring/enums/ClientLevelEnum';
import type { CreditPlanLevelWire } from '@/api/services/loan-offerings/contract';
import {
    segmentDotToneClass,
    segmentToneClass,
    tierToneClass,
    type SegmentColorSlot,
} from '@/shared/patterns/Pills';
import type { ScopeChipTone } from '@/shared/patterns/ScopeChips';

/** Los niveles del plan que son un metal. `ALL` no lo es: no acota a un nivel, los abarca a todos. */
const TIER_BY_PLAN_LEVEL: Partial<Record<CreditPlanLevelWire, ClientLevelEnum>> = {
    BRONZE: ClientLevelEnum.BRONZE,
    SILVER: ClientLevelEnum.SILVER,
    GOLD: ClientLevelEnum.GOLD,
};

// El punto lleva el color fuerte del metal —el mismo del texto de la píldora—, porque el relleno
// pastel del chip es demasiado claro para un disco de 10px.
const TIER_DOT_CLASS: Record<ClientLevelEnum, string> = {
    [ClientLevelEnum.GOLD]: 'bg-tier-gold',
    [ClientLevelEnum.SILVER]: 'bg-tier-silver',
    [ClientLevelEnum.BRONZE]: 'bg-tier-bronze',
    [ClientLevelEnum.NOT_ELIGIBLE]: 'bg-tier-none',
};

/** El metal del nivel. `undefined` ⇒ el chip se queda con el color de la dimensión. */
export function planLevelTone(level: CreditPlanLevelWire): ScopeChipTone | undefined {
    const tier = TIER_BY_PLAN_LEVEL[level];
    if (tier === undefined) return undefined;
    return { chip: tierToneClass(tier), dot: TIER_DOT_CLASS[tier] };
}

/** El color que el catálogo le asignó al segmento, el mismo con el que lo pinta su píldora. */
export function segmentSlotTone(slot: SegmentColorSlot): ScopeChipTone {
    return { chip: segmentToneClass(slot), dot: segmentDotToneClass(slot) };
}
